import React from 'react';
import PropTypes from 'prop-types';
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import stylesGlobal from '../../../../../src/web/theme/facility-globals.scss';
import Icon from '../../../../../modules/react/components/stateless/Icon';
import styles from './FacilityUnitsEditor.scss';

const propTypes = {
  buttons: PropTypes.shape({
    call: PropTypes.string.isRequired,
    moveIn: PropTypes.string.isRequired,
    reserve: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  validateChange: PropTypes.func.isRequired,
};

const FacilityUnitsButtonEditor = ({ buttons, onChange, validateChange }) => {
  const handleChange = ({ target }) => {
    onChange({
      type: 'buttons',
      key: target.name,
      value: target.value,
    });
  };

  return (
    <div className={styles.content}>
      <div className={styles.header}>
        <span className={styles.title}>Button Text</span>
      </div>
      <Form.Group
        className={styles.inputGroup}
        controlId="moveIn"
        validationState={validateChange({ type: 'buttons', key: 'moveIn' })}
      >
        <Form.Label className={styles.label}>
          Move In
          <div className={styles.tooltip}>
            <OverlayTrigger
              overlay={(
                <Tooltip id="moveInTooltip" className={stylesGlobal.tooltip}>
                  <div className={stylesGlobal.tooltipInner}>
                    Opens Rental Center
                  </div>
                </Tooltip>
              )}
              placement="top"
            >
              <span>
                <Icon id="tool-tip" label="Rental Center" />
              </span>
            </OverlayTrigger>
          </div>
        </Form.Label>
        <Form.Control
          name="moveIn"
          onChange={handleChange}
          required
          value={buttons.moveIn}
        />
        <Form.Control.Feedback />
      </Form.Group>
      <Form.Group
        className={styles.inputGroup}
        controlId="reserve"
        validationState={validateChange({ type: 'buttons', key: 'reserve' })}
      >
        <Form.Label className={styles.label}>
          Reserve
          <div className={styles.tooltip}>
            <OverlayTrigger
              overlay={(
                <Tooltip id="reserveTooltip" className={stylesGlobal.tooltip}>
                  <div className={stylesGlobal.tooltipInner}>
                    Opens reservation modal
                  </div>
                </Tooltip>
)}
              placement="top"
            >
              <span>
                <Icon id="tool-tip" label="Reserve" />
              </span>
            </OverlayTrigger>
          </div>
        </Form.Label>
        <Form.Control
          name="reserve"
          onChange={handleChange}
          required
          value={buttons.reserve}
        />
        <Form.Control.Feedback />
      </Form.Group>
      <Form.Group
        className={styles.inputGroup}
        controlId="call"
        validationState={validateChange({ type: 'buttons', key: 'call' })}
      >
        <Form.Label className={styles.label}>
          Call
          <div className={styles.tooltip}>
            <OverlayTrigger
              overlay={(
                <Tooltip id="callTooltip" className={stylesGlobal.tooltip}>
                  <div className={stylesGlobal.tooltipInner}>
                    Displays when unit count is below the set threshold
                  </div>
                </Tooltip>
)}
              placement="top"
            >
              <span>
                <Icon id="tool-tip" label="Call" />
              </span>
            </OverlayTrigger>
          </div>
        </Form.Label>
        <Form.Control
          name="call"
          onChange={handleChange}
          required
          value={buttons.call}
        />
        <Form.Control.Feedback />
      </Form.Group>
    </div>
  );
};

FacilityUnitsButtonEditor.propTypes = propTypes;

export default FacilityUnitsButtonEditor;
